export const trads = {
  all: { en: 'All', fr: 'Tous', es: 'Todos', it: 'Tutti', de: 'Alle' },
};
